import { configureStore } from "@reduxjs/toolkit";
import { accountApi } from "./../store/accountApi";
import { setupApi } from "./../store/setupApi";
import { reservationsApi } from "./../store/reservationsApi";
import { openingHoursApi } from "./../store/openingHoursApi";
import { exceptionsApi } from "./../store/exceptionsApi";
import { themeApi } from "./../store/themeApi";
import { personeelApi } from "./../store/personeelApi";
import { personalTokensApi } from "./../store/personalTokensApi";
import { restaurantApi } from "./../store/restaurantApi";
import { contactsApi } from "./../store/contactsApi";
import { subscriptionApi } from "./../store/subscriptionApi";
import { goldenTicketsApi } from "./../store/goldenTicketsApi";
import { giftcardsApi } from "./../store/giftcardsApi";
import { inboundEmailsApi } from "./../store/inboundEmailsApi";
import avatarReducer from "./reducers/avatarReducer";
import languageReducer from "./reducers/languageReducer";
import { socketMiddleware } from "./../store/socketMiddleware";
import { languageMiddleware } from "./middleware/languageMiddleware";

export const store = configureStore({
  reducer: {
    [setupApi.reducerPath]: setupApi.reducer,
    [accountApi.reducerPath]: accountApi.reducer,
    [reservationsApi.reducerPath]: reservationsApi.reducer,
    [openingHoursApi.reducerPath]: openingHoursApi.reducer,
    [exceptionsApi.reducerPath]: exceptionsApi.reducer,
    [themeApi.reducerPath]: themeApi.reducer,
    [personeelApi.reducerPath]: personeelApi.reducer,
    [personalTokensApi.reducerPath]: personalTokensApi.reducer,
    [restaurantApi.reducerPath]: restaurantApi.reducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [goldenTicketsApi.reducerPath]: goldenTicketsApi.reducer,
    [giftcardsApi.reducerPath]: giftcardsApi.reducer,
    [inboundEmailsApi.reducerPath]: inboundEmailsApi.reducer,
    avatar: avatarReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      accountApi.middleware,
      setupApi.middleware,
      reservationsApi.middleware,
      openingHoursApi.middleware,
      exceptionsApi.middleware,
      themeApi.middleware,
      personeelApi.middleware,
      personalTokensApi.middleware,
      restaurantApi.middleware,
      contactsApi.middleware,
      subscriptionApi.middleware,
      goldenTicketsApi.middleware,
      giftcardsApi.middleware,
      inboundEmailsApi.middleware,
      socketMiddleware,
      languageMiddleware
    ),
});

export default store;
